import { ActionTypes } from '../enhanced-specials/actions-creator';

const initialState = {
  eventIds: [],
  isLoaded: false
};

export default function reducer(state = initialState, action) {

  switch (action.type) {
    case ActionTypes.GET_ENHANCED_SPECIALS_SUCCESS: {
      return {
        ...state,
        eventIds: action.eventIds,
        isLoaded: true
      };
    }
    default:
      return state;
  }
}
